import { createSlice } from '@reduxjs/toolkit'
import Sentry from 'src/utils/sentry'
import { API } from 'src/utils/interceptor'
import { setFeatureLimit } from './VenueSlice'

const initialState = {
  isLoading: false,
  error: null,
  pricesList: [],
}
const subscriptionSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    setPricesList(state, action) {
      state.pricesList = action.payload
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
  },
})

export const getPricesList = () => async dispatch => {
  try {
    dispatch(setIsLoading(true))
    const data = await API.get('api', `get-prices`)
    dispatch(setPricesList(data))
    dispatch(setIsLoading(false))
  } catch (error) {
    dispatch(setIsLoading(false))
    Sentry.captureException(error)
    dispatch(setError(error))
    console.log(error)
  }
}

/**
 * Stripe Billing quickstart: create hosted Checkout Session.
 * Returns { data: { checkoutMode: 'hosted', url, sessionId } }.
 */
export const makePayment = body => async dispatch => {
  try {
    dispatch(setIsLoading(true))
    const response = await API.post('api', `payment-sheet`, {
      body: {
        venueId: body.venueId,
        priceId: body.priceId,
        ...(body.discountId && { discountId: body.discountId }),
      },
    })
    dispatch(setIsLoading(false))
    return response
  } catch (error) {
    dispatch(setIsLoading(false))
    Sentry.captureException(error)
    console.log(error)
    return {
      success: false,
      error:
        error?.response?.data?.message || error?.message || 'Payment failed',
    }
  }
}

export const getSubscriptionData = subsriptionId => async dispatch => {
  try {
    dispatch(setIsLoading(true))
    const data = await API.get('api', `get-subscription-data/${subsriptionId}`)
    return data
  } catch (error) {
    Sentry.captureException(error)
    console.log(error)
    return null
  } finally {
    dispatch(setIsLoading(false))
  }
}

export const cancelSubscription =
  (subscriptionId, venueId) => async dispatch => {
    try {
      const response = await API.del(
        'api',
        `cancel-subscription/${subscriptionId}/${venueId}`,
      )
      return response
    } catch (error) {
      dispatch(setIsLoading(false))
      Sentry.captureException(error)
      console.log(error)
    }
  }

export const cancelDowngrade = cancelSubscriptionId => async dispatch => {
  try {
    const response = await API.del(
      'api2',
      `venue/cancelDonwgrade/${cancelSubscriptionId}`,
    )
    return response
  } catch (error) {
    dispatch(setIsLoading(false))
    Sentry.captureException(error)
    console.log(error)
  }
}

export const updateFeatureLimit = (venueId, feature) => async dispatch => {
  const { updatedLimit } = await API.post(
    'api2',
    `venue/${venueId}/updateFeatureLimit`,
    { body: { feature } },
  )
  dispatch(setFeatureLimit({ feature, limit: updatedLimit }))
}
export const { setIsLoading, setPricesList, setError } =
  subscriptionSlice.actions

export default subscriptionSlice
